<template>
  <b-container>
    <div class="row justify-content-center">
      <div class="col-lg-6" v-if="meeting">
        <h1>Rate Your Advisor</h1>

        <div class="box profile">
          <img
            class="img-profile img-fluid rounded-circle mb-16"
            :src="meeting.inviter.uuid === $auth.user().uuid ? meeting.invitee.avatar : meeting.inviter.avatar"
          />

          <div class="display-4 mb-8">
            <span v-if="meeting.inviter.uuid === $auth.user().uuid">
              {{ meeting.invitee.first_name }} {{ meeting.invitee.last_name }}
            </span>

            <span v-if="meeting.invitee.uuid === $auth.user().uuid">
              {{ meeting.inviter.first_name }} {{ meeting.inviter.last_name }}
            </span>
          </div>

          <p>
            You met with
            {{ meeting.inviter.uuid === $auth.user().uuid ? meeting.invitee.first_name : meeting.inviter.first_name  }}
            on {{ meeting.date }}
          </p>

          <b-form @submit.prevent="submit">
            <div class="d-flex justify-content-center mb-3">
              <star-rating :show-rating="false" :increment="0.5" v-model="rating" />
            </div>

            <hr>

            <h3 class="text-left">How did the meeting go?</h3>
            <b-form-group>
              <b-form-textarea class="mb-16" rows="3" v-model="notes" :disabled="loading" />
            </b-form-group>

            <b-btn
              type="submit" :disabled="loading"
              variant="secondary" size="lg" block
            >
              Submit Rating
            </b-btn>
          </b-form>
        </div>
      </div>
    </div>
  </b-container>
</template>

<script>
import StarRating from 'vue-star-rating'

export default {
  name: 'ReviewsAdd',
  components: {
    StarRating
  },
  data () {
    return {
      uuid: null,
      meeting: null,
      rating: 0,
      notes: '',
      loading: false
    }
  },
  mounted () {
    this.uuid = this.$route.params.uuid
    this.load()
  },
  methods: {
    load () {
      this.loading = true
      this.$http
        .get(`/meetings/${this.uuid}`)
        .then(
          (res) => {
            this.meeting = res.data.data
          },
          () => {}
        )
        .finally(() => {
          this.loading = false
        })
    },
    submit () {
      this.loading = true
      this.$http
        .post(`/meetings/${this.uuid}`, {
          rating: this.rating,
          notes: this.notes
        })
        .then(
          () => {
            this.$router.push('/reviews')
          },
          () => {}
        )
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>
.img-profile { width: 96px; }
</style>
